import type { TFunction } from "i18next";
import { z } from "zod";
import {
  getOperationsDocumentsSchema,
  getRequiredOperationsReasonSchema,
  OPERATIONS_DETAILS_MAX_LENGTH,
  OPERATIONS_DOCUMENTS_MAX_FILES,
} from "./operationsDisputeSchema";

export const DISPUTE_DOCUMENT_FIELD = "disputeDocuments" as const;
export const DISPUTE_REASON_MAX_LENGTH = OPERATIONS_DETAILS_MAX_LENGTH;
export const DISPUTE_DOCUMENTS_MAX_FILES = OPERATIONS_DOCUMENTS_MAX_FILES;

export const getDisputeDrawerSchema = (t: TFunction, includeAssociatedMovement = true) =>
  z.object({
    associatedMovementId: includeAssociatedMovement
      ? z.string().min(
          1,
          t("form-validation.mandatory", {
            label: t("vessel-call.operations.associated-movement"),
          }),
        )
      : z.string().optional(),
    disputeReason: getRequiredOperationsReasonSchema(t, t("vessel-call.operations.dispute-reason")),
    [DISPUTE_DOCUMENT_FIELD]: getOperationsDocumentsSchema(
      t,
      t("vessel-call.operations.dispute-documents"),
    ),
  });
